import React from 'react'
import c from 'classnames'
import { connect } from 'react-redux'
import { Flipper, Flipped } from 'react-flip-toolkit'
import Button from 'discada/dist/Button'

import { INTENTS, INTENTS_EMOJI, INTENTS_LABELS } from 'reducers/quoteReducers'

import { trackReaction } from 'actions/quoteActions'
import { getTaggedCustomerFromState } from 'selectors/appStatusSelectors'
import { addToPageState, toggleQueryValue } from 'actions/pageStateActions'
import { getQueryValue } from 'selectors/pageStateSelectors'
import { showPaymentRange, shouldShowPrice } from 'selectors/quoteSelectors'

import './Reactions.scss'

export class Reactions extends React.Component {
  state = { loaded: false }

  componentDidMount() {
    this.setState({ loaded: true })
  }

  render() {
    let {
        vehicleId,
        quoteId,
        mode,
        trackReaction,
        customer,
        addToPageState,
        toggleQueryValue,
        isCustomizing,
        showCustomize,
        showGetOTD,
        showPrice,
      } = this.props,
      { loaded } = this.state,
      { firstName } = customer,
      onClick = action => () => {
        action === INTENTS.customize
          ? toggleQueryValue('showSurvey', true)
          : addToPageState({ mode, quoteAction: action }, null, true)

        if (action !== INTENTS.customize || !isCustomizing)
          trackReaction(vehicleId, quoteId, action)
      },
      intents = [
        INTENTS.buyNow,
        showGetOTD && INTENTS.getOTD,
        INTENTS.accepted,
        INTENTS.tradeAppraisal,
        showCustomize && INTENTS.customize,
        INTENTS.shared,
        INTENTS.revised,
        !showGetOTD && mode !== 'cash' && INTENTS.rolled,
        !showPrice && INTENTS.getCashPrice,
        mode !== 'cash' && INTENTS.rejected,
        showPrice && mode === 'cash' && INTENTS.cashRejected,
      ],
      cashOtdLabel = (
        <span>
          Show me a <strong>personalized</strong> price.
        </span>
      )

    return (
      <div className="reactions">
        <div className="reactions-inner">
          <h5>
            So{firstName ? <strong> {firstName}</strong> : null}, what do you
            think?
          </h5>
          {loaded && (
            <Flipper flipKey={intents.join()}>
              {intents
                .filter(x => x)
                .map(k => {
                  let label =
                    mode === 'cash' && k === INTENTS.getOTD
                      ? cashOtdLabel
                      : INTENTS_LABELS[k]

                  return (
                    <Flipped flipId={k} key={k} stagger>
                      <div>
                        <ReactionButton
                          emoji={INTENTS_EMOJI[k]}
                          onClick={onClick(k)}
                          className={k}
                          label={label}
                        />
                      </div>
                    </Flipped>
                  )
                })}
            </Flipper>
          )}
        </div>
      </div>
    )
  }
}

export const ReactionButton = ({
  onClick,
  className,
  emoji,
  label,
  size = 'regular',
}) => {
  return (
    <Button
      size={size}
      rounded
      onClick={onClick}
      className={c('reaction-button', className, `reaction-button-${size}`)}
    >
      <span className="reaction-content">
        {emoji} "{label}"
      </span>
    </Button>
  )
}

function mapStateToProps(state, op) {
  return {
    ...op,
    customer: getTaggedCustomerFromState(state),
    isCustomizing: getQueryValue(state, 'showSurvey'),
    showCustomize: getQueryValue(state, 'h'),
    showGetOTD: showPaymentRange(state, op.vehicleId, op.quoteId),
    showPrice: shouldShowPrice(state, op.vehicleId, op.quoteId),
  }
}

export default connect(
  mapStateToProps,
  { trackReaction, addToPageState, toggleQueryValue },
)(Reactions)
